<template>
  <app-badge
    :color="badgeColor"
    size="sm"
  >
    {{ status }}
  </app-badge>
</template>

<script setup>
import { computed } from 'vue';
import { UserStatus } from '@/constants/users';

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: (value) => Object.values(UserStatus).includes(value),
  },
});

const badgeColor = computed(() => {
  return {
    [UserStatus.ACTIVE]: 'success',
    [UserStatus.BLOCKED]: 'error',
  }[props.status];
});
</script>
